
import React from "../../../../lib/teact/teact";
import { getDateStringVN } from "../../utils/DateTimeUtils";
import { tienFormat } from "../../utils/NumberUtils";
import _ from 'lodash'
import { DecimalAdd, GetLaiLoByPhanTramThau, GetTextTienHoi, GetTotalLaiLoText, TinhTienHoi } from "./reportTemplete";
/* Mẫu 4: miền tây
Thứ…, ngày… Khách
Tên khách
MN: 2C…da…dx… 3C…4C… (tiền qua cò)
Trúng: 2C… da…dx…3C…4C…(tiền trúng)
(Nếu là chuyển cho Chủ)
Thu = Lãi hay Bù = Lỗ * 0.95
(Nếu là nhận của khách)
Thu = Lãi * 0.95 hay Bù = Lỗ
*/
type groupItemKeyXacQuaCo = 'Lo2C' | 'Lo3C' | '2CDD' | '4C' | 'dat' | 'dax' | 'XMB' | 'AB3C'
type groupItemKeyTrungThuong = 'Lo2C' | 'Lo3C' | '2CDD' | '4C' | 'dat' | 'dax' | 'XMB' | 'AB3C'
type GroupMapXacQuaCo = Record<groupItemKeyXacQuaCo, number>;
type GroupMapTrungThuong = Record<groupItemKeyTrungThuong, number>;
const templeteMienTay_details: { [key: string]: groupItemKeyXacQuaCo } = {
    "6Lo2c": "Lo2C",
    "DKC": "Lo2C",
    '6Lo3C': 'Lo3C',
    '7Lo2C': 'Lo2C',
    '8Lo2C': 'Lo2C',
    '7Lo3C': 'Lo3C',
    'DaT': 'dat',
    'Dau2C': '2CDD',
    'Dau4C': '4C',
    'DaX': 'dax',
    'Duoi2C': '2CDD',
    'Duoi4C': '4C',
    'Lo2C': 'Lo2C',
    'Lo3C': 'Lo3C',
    'Lo4C': '4C',
    'XC': 'AB3C',
    'XcDau': 'AB3C',
    'XcDuoi': 'AB3C',
    'Xi2': 'XMB',
    'Xi3': 'XMB',
    'Xi4': 'XMB',
}
const templeteMienTayMau5_total = {
    message: {} as any,
    MIEN: '',
    NGAY: '',
    //Qua cò
    QuaCo: {
        'Lo2C': 0,
        'Lo3C': 0,
        'AB3C': 0,
        '2CDD': 0,
        'dat': 0,
        'dax': 0,
        '4C': 0,
        'XMB': 0,
    } as GroupMapXacQuaCo,
    Xac: {
        'Lo2C': 0,
        'Lo3C': 0,

        'AB3C': 0,
        '2CDD': 0,
        'dat': 0,
        'dax': 0,
        '4C': 0,
        'XMB': 0,
    } as GroupMapXacQuaCo,
    //Tiền thưởng
    Trung: {
        'Lo3C': 0,
        'Lo2C': 0,
        'dat': 0,
        'dax': 0,
        '2CDD': 0,
        'AB3C': 0,
        '4C': 0,
        'XMB': 0
    } as GroupMapTrungThuong,
    TienTrung: {
        'Lo3C': 0,
        'Lo2C': 0,
        'dat': 0,
        'dax': 0,
        '2CDD': 0,
        'AB3C': 0,
        '4C': 0,
        'XMB': 0
    } as GroupMapTrungThuong,

    GetLaiLo: function () {
        let quaCo = 0;
        let tienThuong = 0;
        Object.keys(this.QuaCo).forEach(key => {
            quaCo += this.QuaCo[key as groupItemKeyXacQuaCo];
        })
        Object.keys(this.TienTrung).forEach(key => {
            tienThuong += this.TienTrung[key as groupItemKeyTrungThuong];
        })
        return quaCo - tienThuong;
    },
    GetSMS: function () {
        let sms = "";
        sms += this.MIEN + ":"
        if (this.QuaCo['Lo2C'] != 0) {
            sms += `Lô2C:${tienFormat(this.Xac['Lo2C'], 1)}=`
            sms += `${tienFormat(this.QuaCo['Lo2C'], 1)}n\r\n`
        }
        if (this.QuaCo['2CDD'] != 0) {
            sms += `AB:${tienFormat(this.Xac['2CDD'], 1)}=`
            sms += `${tienFormat(this.QuaCo['2CDD'], 1)}n\r\n`
        }
        if (this.QuaCo['Lo3C'] != 0) {
            sms += `Lô3C:${tienFormat(this.Xac['Lo3C'], 1)}=`
            sms += `${tienFormat(this.QuaCo['Lo3C'], 1)}n\r\n`
        }
        if (this.QuaCo['AB3C'] != 0) {
            sms += `AB 3C:${tienFormat(this.Xac['AB3C'], 1)}=`
            sms += `${tienFormat(this.QuaCo['AB3C'], 1)}n\r\n`
        }

        if (this.QuaCo['dat'] != 0) {
            sms += `Đá thẳng:${tienFormat(this.Xac['dat'], 1)}=`
            sms += `${tienFormat(this.QuaCo['dat'], 1)}n\r\n`
        }
        if (this.QuaCo['dax'] != 0) {
            sms += `Đá xiên:${tienFormat(this.Xac['dax'], 1)}=`
            sms += `${tienFormat(this.QuaCo['dax'], 1)}n\r\n`
        }


        if (this.QuaCo['4C'] != 0) {
            sms += `4C:${tienFormat(this.Xac['4C'], 1)}=`
            sms += `${tienFormat(this.QuaCo['4C'], 1)}n\r\n`
        }
        if (this.QuaCo['XMB'] != 0) {
            sms += `XMB:${tienFormat(this.Xac['XMB'], 1)}=`
            sms += `${tienFormat(this.QuaCo['XMB'], 1)}n\r\n`
        }
        //tien thuong
        let tmp = ""
        if (this.TienTrung['Lo2C'] != 0) {
            tmp += `Lô 2C:${this.Trung['Lo2C']}=${tienFormat(this.TienTrung['Lo2C'], 1)}n\r\n`
        }
        if (this.TienTrung['2CDD'] != 0) {
            tmp += `AB:${this.Trung['2CDD']}=${tienFormat(this.TienTrung['2CDD'], 1)}n\r\n`
        }
        if (this.TienTrung['Lo3C']! + 0) {
            tmp += `Lô 3C:${this.Trung['Lo3C']}=${tienFormat(this.TienTrung['Lo3C'], 1)}n\r\n`
        }
        if (this.TienTrung['AB3C']! + 0) {
            tmp += `AB 3C:${this.Trung['AB3C']}=${tienFormat(this.TienTrung['AB3C'], 1)}n\r\n`
        }
        if (this.TienTrung['dat'] != 0) {
            tmp += `Đá thằng:${this.Trung['dat']}=${tienFormat(this.TienTrung['dat'], 1)}n\r\n`
        }
        if (this.TienTrung['dax'] != 0) {
            tmp += `Đá xiên:${this.Trung['dax']}=${tienFormat(this.TienTrung['dax'], 1)}n\r\n`
        }

        if (this.TienTrung['4C'] != 0) {
            tmp += `4c:${this.Trung['4C']}=${tienFormat(this.TienTrung['4C'], 1)}n\r\n`
        }
        if (this.TienTrung['XMB'] != 0) {
            tmp += `XMB:${this.Trung['XMB']}=${tienFormat(this.TienTrung['XMB'], 1)}n\r\n`
        }
        if (tmp != "") {
            sms += "\r\nTrúng:" + tmp
        }
        const laiLo = this.GetLaiLo()
        const laiLoSauPt = laiLo / 100 * (100 - this.message.phanTramThau)
        const tienHoiSauPt = TinhTienHoi(this.message)
        if (laiLo > 0) {
            sms += "\r\nThu:" + GetLaiLoByPhanTramThau(laiLo, this.message.phanTramThau) + GetTextTienHoi(laiLoSauPt, tienHoiSauPt)
        } else if (laiLo < 0) {
            sms += "\r\nBù:" + GetLaiLoByPhanTramThau(laiLo, this.message.phanTramThau) + GetTextTienHoi(laiLoSauPt, tienHoiSauPt)
        } else {
            sms += "\r\nHoà"
        }
        sms += "\r\n-----\r\n"
        return sms;
    }
}
export function getSMSMau5_1MienTay(
    messages1: any,
    returnJSX: boolean = false,
    returnHTML: boolean = false,
): string | any {
    const messages = Array.isArray(messages1) ? messages1 : (messages1 ? [messages1] : []);
    let smss: typeof templeteMienTayMau5_total[] = [];
    let ngay = ""
    let ten = ""
    let phanTramThau = 0
    messages && messages.length > 0 && messages.map((msg: any) => {
        let mien = "MN";
        if (msg.key == 1)
            mien = "MB";
        if (msg.key == 2)
            mien = "MT";

        let curSms: typeof templeteMienTayMau5_total = _.cloneDeep(templeteMienTayMau5_total);
        ngay = getDateStringVN(msg.date)
        curSms.MIEN = mien;
        curSms.message = msg
        ten = msg.contactName;
        phanTramThau = msg.phanTramThau;
        smss.push(curSms);
        msg.children && msg.children.map((group: any) => {
            group.children && group.children.map((item: any) => {
                const loaiCuocId: string = item.loaiCuocId;
                const groupId: string = templeteMienTay_details[loaiCuocId];
                switch (loaiCuocId) {
                    case "6Lo2c":
                        curSms.TienTrung["Lo2C"] = DecimalAdd(curSms.TienTrung["Lo2C"], item.thuong)
                        curSms.Trung["Lo2C"] = DecimalAdd(curSms.Trung["Lo2C"], item.trung)

                        curSms.QuaCo["Lo2C"] = DecimalAdd(curSms.QuaCo["Lo2C"], item.quaCo)
                        curSms.Xac["Lo2C"] = DecimalAdd(curSms.Xac["Lo2C"], item.xac)
                        break;
                    case "DKC":
                        curSms.TienTrung["Lo2C"] = DecimalAdd(curSms.TienTrung["Lo2C"], item.thuong)
                        curSms.Trung["Lo2C"] = DecimalAdd(curSms.Trung["Lo2C"], item.trung)
                        curSms.QuaCo["Lo2C"] = DecimalAdd(curSms.QuaCo["Lo2C"], item.quaCo)
                        curSms.Xac["Lo2C"] = DecimalAdd(curSms.Xac["Lo2C"], item.xac)
                        break;
                    case '6Lo3C':
                        curSms.TienTrung["Lo3C"] = DecimalAdd(curSms.TienTrung["Lo3C"], item.thuong)
                        curSms.Trung["Lo3C"] = DecimalAdd(curSms.Trung["Lo3C"], item.trung)

                        curSms.QuaCo["Lo3C"] = DecimalAdd(curSms.QuaCo["Lo3C"], item.quaCo)
                        curSms.Xac["Lo3C"] = DecimalAdd(curSms.Xac["Lo3C"], item.xac)
                        break;
                    case '7Lo2C':
                        curSms.TienTrung["Lo2C"] = DecimalAdd(curSms.TienTrung["Lo2C"], item.thuong)
                        curSms.Trung["Lo2C"] = DecimalAdd(curSms.Trung["Lo2C"], item.trung)

                        curSms.QuaCo["Lo2C"] = DecimalAdd(curSms.QuaCo["Lo2C"], item.quaCo)
                        curSms.Xac["Lo2C"] = DecimalAdd(curSms.Xac["Lo2C"], item.xac)
                        break;
                    case '8Lo2C':
                        curSms.TienTrung["Lo2C"] = DecimalAdd(curSms.TienTrung["Lo2C"], item.thuong)
                        curSms.Trung["Lo2C"] = DecimalAdd(curSms.Trung["Lo2C"], item.trung)

                        curSms.QuaCo["Lo2C"] = DecimalAdd(curSms.QuaCo["Lo2C"], item.quaCo)
                        curSms.Xac["Lo2C"] = DecimalAdd(curSms.Xac["Lo2C"], item.xac)
                        break;
                    case '7Lo3C':
                        curSms.TienTrung["Lo3C"] = DecimalAdd(curSms.TienTrung["Lo3C"], item.thuong)
                        curSms.Trung["Lo3C"] = DecimalAdd(curSms.Trung["Lo3C"], item.trung)

                        curSms.QuaCo["Lo3C"] = DecimalAdd(curSms.QuaCo["Lo3C"], item.quaCo)
                        curSms.Xac["Lo3C"] = DecimalAdd(curSms.Xac["Lo3C"], item.xac)
                        break;
                    case 'DaT':
                        curSms.TienTrung["dat"] = DecimalAdd(curSms.TienTrung["dat"], item.thuong)
                        curSms.Trung["dat"] = DecimalAdd(curSms.Trung["dat"], item.trung)

                        curSms.QuaCo["dat"] = DecimalAdd(curSms.QuaCo["dat"], item.quaCo)
                        curSms.Xac["dat"] = DecimalAdd(curSms.Xac["dat"], item.xac)
                        break;
                    case 'Dau2C':
                        curSms.TienTrung["2CDD"] = DecimalAdd(curSms.TienTrung["2CDD"], item.thuong)
                        curSms.Trung["2CDD"] = DecimalAdd(curSms.Trung["2CDD"], item.trung)

                        curSms.QuaCo["2CDD"] = DecimalAdd(curSms.QuaCo["2CDD"], item.quaCo)
                        curSms.Xac["2CDD"] = DecimalAdd(curSms.Xac["2CDD"], item.xac)
                        break;
                    case 'Dau4C':
                        curSms.TienTrung["4C"] = DecimalAdd(curSms.TienTrung["4C"], item.thuong)
                        curSms.Trung["4C"] = DecimalAdd(curSms.Trung["4C"], item.trung)

                        curSms.QuaCo["4C"] = DecimalAdd(curSms.QuaCo["4C"], item.quaCo)
                        curSms.Xac["4C"] = DecimalAdd(curSms.Xac["4C"], item.xac)
                        break;
                    case 'DaX':
                        curSms.TienTrung["dax"] = DecimalAdd(curSms.TienTrung["dax"], item.thuong)
                        curSms.Trung["dax"] = DecimalAdd(curSms.Trung["dax"], item.trung)

                        curSms.QuaCo["dax"] = DecimalAdd(curSms.QuaCo["dax"], item.quaCo)
                        curSms.Xac["dax"] = DecimalAdd(curSms.Xac["dax"], item.xac)
                        break;
                    case 'Duoi2C':
                        curSms.TienTrung["2CDD"] = DecimalAdd(curSms.TienTrung["2CDD"], item.thuong)
                        curSms.Trung["2CDD"] = DecimalAdd(curSms.Trung["2CDD"], item.trung)

                        curSms.QuaCo["2CDD"] = DecimalAdd(curSms.QuaCo["2CDD"], item.quaCo)
                        curSms.Xac["2CDD"] = DecimalAdd(curSms.Xac["2CDD"], item.xac)
                        break;
                    case 'Duoi4C':
                        curSms.TienTrung["4C"] = DecimalAdd(curSms.TienTrung["4C"], item.thuong)
                        curSms.Trung["4C"] = DecimalAdd(curSms.Trung["4C"], item.trung)

                        curSms.QuaCo["4C"] = DecimalAdd(curSms.QuaCo["4C"], item.quaCo)
                        curSms.Xac["4C"] = DecimalAdd(curSms.Xac["4C"], item.xac)
                        break;
                    case 'Lo2C':
                        curSms.TienTrung["Lo2C"] = DecimalAdd(curSms.TienTrung["Lo2C"], item.thuong)
                        curSms.Trung["Lo2C"] = DecimalAdd(curSms.Trung["Lo2C"], item.trung)

                        curSms.QuaCo["Lo2C"] = DecimalAdd(curSms.QuaCo["Lo2C"], item.quaCo)
                        curSms.Xac["Lo2C"] = DecimalAdd(curSms.Xac["Lo2C"], item.xac)
                        break;
                    case 'Lo3C':
                        curSms.TienTrung["Lo3C"] = DecimalAdd(curSms.TienTrung["Lo3C"], item.thuong)
                        curSms.Trung["Lo3C"] = DecimalAdd(curSms.Trung["Lo3C"], item.trung)

                        curSms.QuaCo["Lo3C"] = DecimalAdd(curSms.QuaCo["Lo3C"], item.quaCo)
                        curSms.Xac["Lo3C"] = DecimalAdd(curSms.Xac["Lo3C"], item.xac)
                        break;
                    case 'Lo4C':
                        curSms.TienTrung["4C"] = DecimalAdd(curSms.TienTrung["4C"], item.thuong)
                        curSms.Trung["4C"] = DecimalAdd(curSms.Trung["4C"], item.trung)

                        curSms.QuaCo["4C"] = DecimalAdd(curSms.QuaCo["4C"], item.quaCo)
                        curSms.Xac["4C"] = DecimalAdd(curSms.Xac["4C"], item.xac)
                        break;
                    case 'XC':
                        curSms.TienTrung["AB3C"] = DecimalAdd(curSms.TienTrung["AB3C"], item.thuong)
                        curSms.Trung["AB3C"] = DecimalAdd(curSms.Trung["AB3C"], item.trung)

                        curSms.QuaCo["AB3C"] = DecimalAdd(curSms.QuaCo["AB3C"], item.quaCo)
                        curSms.Xac["AB3C"] = DecimalAdd(curSms.Xac["AB3C"], item.xac)
                        break;
                    case 'XcDau':
                        curSms.TienTrung["AB3C"] = DecimalAdd(curSms.TienTrung["AB3C"], item.thuong)
                        curSms.Trung["AB3C"] = DecimalAdd(curSms.Trung["AB3C"], item.trung)

                        curSms.QuaCo["AB3C"] = DecimalAdd(curSms.QuaCo["AB3C"], item.quaCo)
                        curSms.Xac["AB3C"] = DecimalAdd(curSms.Xac["AB3C"], item.xac)
                        break;
                    case 'XcDuoi':
                        curSms.TienTrung["AB3C"] = DecimalAdd(curSms.TienTrung["AB3C"], item.thuong)
                        curSms.Trung["AB3C"] = DecimalAdd(curSms.Trung["AB3C"], item.trung)

                        curSms.QuaCo["AB3C"] = DecimalAdd(curSms.QuaCo["AB3C"], item.quaCo)
                        curSms.Xac["AB3C"] = DecimalAdd(curSms.Xac["AB3C"], item.xac)
                        break;
                    case 'Xi2':
                        curSms.TienTrung["XMB"] = DecimalAdd(curSms.TienTrung["XMB"], item.thuong)
                        curSms.Trung["XMB"] = DecimalAdd(curSms.Trung["XMB"], item.trung)

                        curSms.QuaCo["XMB"] = DecimalAdd(curSms.QuaCo["XMB"], item.quaCo)
                        curSms.Xac["XMB"] = DecimalAdd(curSms.Xac["XMB"], item.xac)
                        break;
                    case 'Xi3':
                        curSms.TienTrung["XMB"] = DecimalAdd(curSms.TienTrung["XMB"], item.thuong)
                        curSms.Trung["XMB"] = DecimalAdd(curSms.Trung["XMB"], item.trung)

                        curSms.QuaCo["XMB"] = DecimalAdd(curSms.QuaCo["XMB"], item.quaCo)
                        curSms.Xac["XMB"] = DecimalAdd(curSms.Xac["XMB"], item.xac)
                        break;
                    case 'Xi4':
                        curSms.TienTrung["XMB"] = DecimalAdd(curSms.TienTrung["XMB"], item.thuong)
                        curSms.Trung["XMB"] = DecimalAdd(curSms.Trung["XMB"], item.trung)

                        curSms.QuaCo["XMB"] = DecimalAdd(curSms.QuaCo["XMB"], item.quaCo)
                        curSms.Xac["XMB"] = DecimalAdd(curSms.Xac["XMB"], item.xac)
                        break;
                    default:
                        console.log('Bổ xung loại cược mới', loaiCuocId)
                }
            })
        })
    })
    let zSms = "Ngày:" + ngay + ". " + ten + "\r\n"
    let laiLo = 0;
    let tienHoiSauPt = 0;
    smss.forEach(sms => {
        zSms += sms.GetSMS()
        laiLo += sms.GetLaiLo()
        tienHoiSauPt += TinhTienHoi(sms.message)
    })
    const laiLoSauPt = laiLo / 100 * (100 - phanTramThau)
    if (messages.length > 1) {
        if (laiLo > 0) {
            zSms += "\r\nTổng cộng thu:" + GetLaiLoByPhanTramThau(laiLo, phanTramThau) + GetTextTienHoi(laiLoSauPt, tienHoiSauPt)
        } else if (laiLo < 0) {
            zSms += "\r\nTổng cộng bù:" + GetLaiLoByPhanTramThau(laiLo, phanTramThau) + GetTextTienHoi(laiLoSauPt, tienHoiSauPt)
        } else {
            zSms += "\r\nTổng cộng hoà"
        }
    }
    console.log(zSms)
    if (returnJSX) {
        let jsxs: JSX.Element[] = [];
        smss.forEach(sms => {
            jsxs.push(<table className="table-total">
                <thead>
                    <tr>
                        <th className="table-header">Loại</th>
                        <th className="table-header">Xác</th>
                        <th className="table-header">Qua cò</th>
                        <th className="table-header">Trúng</th>
                    </tr>
                </thead>
                <tbody>
                    {(sms.Xac['Lo2C'] != 0) && <tr>
                        <td className={"group-row-data loaicuoc"}>Lô 2C</td>
                        <td className={"group-row-data"}>{tienFormat(sms.Xac['Lo2C'], 1)}</td>
                        <td className={"group-row-data"}>{tienFormat(sms.QuaCo['Lo2C'], 1)}</td>
                        <td className={"group-row-data" + (sms.Trung['Lo2C'] != 0 ? " trung" : "")}> {tienFormat(sms.Trung['Lo2C'], 1)}</td>
                    </tr>}
                    {(sms.Xac['Lo3C'] != 0) && <tr>
                        <td className={"group-row-data loaicuoc"}>Lô 3C</td>
                        <td className={"group-row-data"}>{tienFormat(sms.Xac['Lo3C'], 1)}</td>
                        <td className={"group-row-data"}>{tienFormat(sms.QuaCo['Lo3C'], 1)}</td>
                        <td className={"group-row-data" + (sms.Trung['Lo3C'] != 0 ? " trung" : "")}> {tienFormat(sms.Trung['Lo3C'], 1)}</td>
                    </tr>}
                    {(sms.Xac['2CDD'] != 0) && <tr>
                        <td className={"group-row-data loaicuoc"}>AB</td>
                        <td className={"group-row-data"}>{tienFormat(sms.Xac['2CDD'], 1)}</td>
                        <td className={"group-row-data"}>{tienFormat(sms.QuaCo['2CDD'], 1)}</td>
                        <td className={"group-row-data" + (sms.Trung['2CDD'] != 0 ? " trung" : "")}> {tienFormat(sms.Trung['2CDD'], 1)}</td>
                    </tr>}
                    {(sms.Xac['AB3C'] != 0) && <tr>
                        <td className={"group-row-data loaicuoc"}>AB 3C</td>
                        <td className={"group-row-data"}>{tienFormat(sms.Xac['AB3C'], 1)}</td>
                        <td className={"group-row-data"}>{tienFormat(sms.QuaCo['AB3C'], 1)}</td>
                        <td className={"group-row-data" + (sms.Trung['AB3C'] != 0 ? " trung" : "")}> {tienFormat(sms.Trung['AB3C'], 1)}</td>
                    </tr>}
                    {(sms.Xac['4C'] != 0) && <tr>
                        <td className={"group-row-data loaicuoc"}>4C</td>
                        <td className={"group-row-data"}>{tienFormat(sms.Xac['4C'], 1)}</td>
                        <td className={"group-row-data"}>{tienFormat(sms.QuaCo['4C'], 1)}</td>
                        <td className={"group-row-data" + (sms.Trung['4C'] != 0 ? " trung" : "")}> {tienFormat(sms.Trung['4C'], 1)}</td>
                    </tr>}
                    {(sms.Xac['dat'] != 0) && <tr>
                        <td className={"group-row-data loaicuoc"}>ĐáT</td>
                        <td className={"group-row-data"}>{tienFormat(sms.Xac['dat'], 1)}</td>
                        <td className={"group-row-data"}>{tienFormat(sms.QuaCo['dat'], 1)}</td>
                        <td className={"group-row-data" + (sms.Trung['dat'] != 0 ? " trung" : "")}> {tienFormat(sms.Trung['dat'], 1)}</td>
                    </tr>}
                    {(sms.Xac['dax'] != 0) && <tr>
                        <td className={"group-row-data loaicuoc"}>ĐáX</td>
                        <td className={"group-row-data"}>{tienFormat(sms.Xac['dax'], 1)}</td>
                        <td className={"group-row-data"}>{tienFormat(sms.QuaCo['dax'], 1)}</td>
                        <td className={"group-row-data" + (sms.Trung['dax'] != 0 ? " trung" : "")}> {tienFormat(sms.Trung['dax'], 1)}</td>
                    </tr>}
                    {(sms.Xac['XMB'] != 0) && <tr>
                        <td className={"group-row-data loaicuoc"}>XMB</td>
                        <td className={"group-row-data"}>{tienFormat(sms.Xac['XMB'], 1)}</td>
                        <td className={"group-row-data"}>{tienFormat(sms.QuaCo['XMB'], 1)}</td>
                        <td className={"group-row-data" + (sms.Trung['XMB'] != 0 ? " trung" : "")}> {tienFormat(sms.Trung['XMB'], 1)}</td>
                    </tr>}
                    <tr>
                        <td className={"total-row"}>Cộng</td>
                        <td className={"total-row"}> {tienFormat(sms.Xac['Lo2C'] + sms.Xac['Lo3C'] + sms.Xac['2CDD'] + sms.Xac['AB3C'] + sms.Xac['4C'] + sms.Xac['dat'] + sms.Xac['dax'] + sms.Xac['XMB'], 1)}</td>
                        <td className={"total-row"}>{tienFormat(sms.QuaCo['Lo2C'] + sms.QuaCo['Lo3C'] + sms.QuaCo['2CDD'] + sms.QuaCo['AB3C'] + sms.QuaCo['4C'] + sms.QuaCo['dat'] + sms.QuaCo['dax'] + sms.QuaCo['XMB'], 1)}</td>
                        <td className={"total-row"}>{tienFormat(sms.TienTrung['Lo2C'] + sms.TienTrung['Lo3C'] + sms.TienTrung['2CDD'] + sms.TienTrung['AB3C'] + sms.TienTrung['4C'] + sms.TienTrung['dat'] + sms.TienTrung['dax'] + sms.TienTrung['XMB'], 1)}</td>
                    </tr>
                    <tr>
                         <td colSpan={5}
                            className={sms.message.laiLo >= 0 ? "basic-lailo lai" : "basic-lailo lo"}>
                            {GetTotalLaiLoText(sms.message)}


                        </td> 
                    </tr>
                </tbody>
                <tbody></tbody>
            </table>)
        })
        return <div>{jsxs}</div>
    }
    if (returnHTML) {
        const toClass = (isTrung: number) => isTrung != 0 ? "group-row-data trung" : "group-row-data";
        const buildRow = (label: string, xac: number, quaCo: number, trung: number) => `
            <tr>
                <td class="group-row-data loaicuoc">${label}</td>
                <td class="group-row-data">${tienFormat(xac, 1)}</td>
                <td class="group-row-data">${tienFormat(quaCo, 1)}</td>
                <td class="${toClass(trung)}">${tienFormat(trung, 1)}</td>
            </tr>`;
        const htmls: string[] = [];
        smss.forEach(sms => {
            let rows = "";
            if (sms.Xac['Lo2C'] != 0) rows += buildRow("Lô 2C", sms.Xac['Lo2C'], sms.QuaCo['Lo2C'], sms.Trung['Lo2C']);
            if (sms.Xac['Lo3C'] != 0) rows += buildRow("Lô 3C", sms.Xac['Lo3C'], sms.QuaCo['Lo3C'], sms.Trung['Lo3C']);
            if (sms.Xac['2CDD'] != 0) rows += buildRow("AB", sms.Xac['2CDD'], sms.QuaCo['2CDD'], sms.Trung['2CDD']);
            if (sms.Xac['AB3C'] != 0) rows += buildRow("AB 3C", sms.Xac['AB3C'], sms.QuaCo['AB3C'], sms.Trung['AB3C']);
            if (sms.Xac['4C'] != 0) rows += buildRow("4C", sms.Xac['4C'], sms.QuaCo['4C'], sms.Trung['4C']);
            if (sms.Xac['dat'] != 0) rows += buildRow("ĐáT", sms.Xac['dat'], sms.QuaCo['dat'], sms.Trung['dat']);
            if (sms.Xac['dax'] != 0) rows += buildRow("ĐáX", sms.Xac['dax'], sms.QuaCo['dax'], sms.Trung['dax']);
            if (sms.Xac['XMB'] != 0) rows += buildRow("XMB", sms.Xac['XMB'], sms.QuaCo['XMB'], sms.Trung['XMB']);

            htmls.push(`
                <table class="table-total">
                    <thead>
                        <tr>
                            <th class="table-header">Loại</th>
                            <th class="table-header">Xác</th>
                            <th class="table-header">Qua cò</th>
                            <th class="table-header">Trúng</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${rows}
                        <tr>
                            <td class="total-row">Cộng</td>
                            <td class="total-row">${tienFormat(sms.Xac['Lo2C'] + sms.Xac['Lo3C'] + sms.Xac['2CDD'] + sms.Xac['AB3C'] + sms.Xac['4C'] + sms.Xac['dat'] + sms.Xac['dax'] + sms.Xac['XMB'], 1)}</td>
                            <td class="total-row">${tienFormat(sms.QuaCo['Lo2C'] + sms.QuaCo['Lo3C'] + sms.QuaCo['2CDD'] + sms.QuaCo['AB3C'] + sms.QuaCo['4C'] + sms.QuaCo['dat'] + sms.QuaCo['dax'] + sms.QuaCo['XMB'], 1)}</td>
                            <td class="total-row">${tienFormat(sms.TienTrung['Lo2C'] + sms.TienTrung['Lo3C'] + sms.TienTrung['2CDD'] + sms.TienTrung['AB3C'] + sms.TienTrung['4C'] + sms.TienTrung['dat'] + sms.TienTrung['dax'] + sms.TienTrung['XMB'], 1)}</td>
                        </tr>
                        <tr>
                            <td colspan="5" class="basic-lailo ${sms.message.laiLo >= 0 ? "lai" : "lo"}">${GetTotalLaiLoText(sms.message)}</td>
                        </tr>
                    </tbody>
                </table>
            `);
        });
        return `<div>${htmls.join("")}</div>`;
    }
    return zSms;
}
